export default __webpack_public_path__ + "static/media/cycle.48a3af35.png";